import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimesheetFilterState = atomFamily({
  key: "myTimesheetFilterState",
  default: {
    project: [],
    client: [],
    cost: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});

export default myTimesheetFilterState;
